/**
 * Applied when config omits `posAllowed` for isPos users.
 * Prevents `editsallowed` from becoming undefined (template errors on `.editar`, etc.).
 */
export const DEFAULT_POS_ALLOWED = {
	printorder: true,
	discounts: false,
	editar: false,
	credit: false,
	editorder: false,
	editbilling: false,
	editshipping: false,
	editcontact: false,
	editprofile: false,
	editnotes: true,
	takepayment: true,
	viewrma: false,
};

/**
 * `salesmanAllowed ?? DEFAULT` is unsafe: `false`, `0`, or `[]` pass through and break `.editar` access.
 */
export function normalizePosAllowed(fromConfig: unknown): typeof DEFAULT_POS_ALLOWED {
	if (fromConfig !== null && typeof fromConfig === 'object' && !Array.isArray(fromConfig)) {
		return { ...DEFAULT_POS_ALLOWED, ...fromConfig };
	}
	return { ...DEFAULT_POS_ALLOWED };
}

/**
 * Order entry filter strip for issalesman: initial open state.
 * Set explicitly via config `salesmanAllowed.orderEntryFiltersAutoOpen`.
 * If omitted, defaults to true for client `aaprod` only; all other clients false.
 */
export function resolveOrderEntryFiltersAutoOpen(
	config: { env?: { client?: string } } | null | undefined,
	posAllowedRaw: unknown
): boolean {
	const merged = normalizePosAllowed(posAllowedRaw) as Record<string, unknown>;
	const v = merged.orderEntryFiltersAutoOpen;
	if (typeof v === 'boolean') {
		return v;
	}
	return config?.env?.client === 'aaprod';
}
